import React, { useState } from "react";
import { fetchEmployeeCandidates } from "../../api/adminMonitoringApi";
import CandidateRow from "./CandidateRow";

const EmployeeRow = ({ employee, date }) => {
    const [open, setOpen] = useState(false);
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(false);

    const toggle = async () => {
        if (!open && candidates.length === 0) {
            setLoading(true);
            try {
                const res = await fetchEmployeeCandidates(employee.employeeId, date);
                setCandidates(res.data);
            } catch (e) {
                alert("Failed to load candidates");
            } finally {
                setLoading(false);
            }
        }
        setOpen(!open);
    };

    return (
        <div className="employee-row">
            <div className="employee-summary" onClick={toggle}>
                <span className="arrow">{open ? "▼" : "▶"}</span>

                <span className="employee-name">
                    {employee.employeeName}
                </span>

                <span>
                    Candidates: {employee.assignedCandidates}
                </span>

                <span className="numbers">
                    {employee.applied} / {employee.target}
                </span>



                <span className={`gap ${employee.gap < 0 ? "negative" : "positive"}`}>
                    Gap: {employee.gap}
                </span>
            </div>

            {open && (
                <div className="candidate-container">
                    {loading ? (
                        <p className="loading">Loading candidates...</p>
                    ) : candidates.length === 0 ? (
                        <p className="empty">No candidates assigned</p>
                    ) : (
                        candidates.map(c => (
                            <CandidateRow key={c.candidateId} candidate={c} />
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default EmployeeRow;
